module.exports = __webpack_public_path__ + "img/iot_devices.ba95c458.svg";